module.exports = __webpack_public_path__ + "img/control-supply-corp.650c7962.png";